import React from "react";
import Hero from "./components/Hero";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./styles/main.css";
import "./styles/responsive.css";

const MLP = () => {
  return (
    <div className="webp lp lp--mlp">
      <div className="top-fog top-fog--lp" />
      <Header />
      <Hero />
      <Footer />
    </div>
  );
};

export default MLP;
